
import { useState } from 'react';

export default function Module4() {
  const [activeSection, setActiveSection] = useState<number | null>(null);
  const [currentStep, setCurrentStep] = useState(0);

  const sections = [
    {
      id: 1,
      title: "\"一般贸易\" vs \"市场采购\"对比表",
      subtitle: "全维度深度对比",
      icon: "ri-contrast-2-line",
      content: {
        description: "从8个核心维度全面对比两种贸易方式的差异，帮助企业做出最优选择",
        comparisonTable: [
          {
            dimension: "政策核心",
            generalTrade: {
              value: "单笔交易，依法退税",
              detail: "每笔交易独立申报，享受出口退税政策",
              advantage: "可享受退税红利，增加企业利润",
              challenge: "需要完整的进项发票链条"
            },
            marketPurchase: {
              value: "市场集聚，免征增值税",
              detail: "在试点市场内集中采购，免征增值税",
              advantage: "无需发票即可合法出口",
              challenge: "不享受退税，需权衡税收成本"
            }
          },
          {
            dimension: "出口主体",
            generalTrade: {
              value: "有外贸权企业",
              detail: "必须具备进出口经营权的正规企业",
              advantage: "操作规范，客户信任度高",
              challenge: "门槛相对较高，需要资质"
            },
            marketPurchase: {
              value: "市场内备案的企业",
              detail: "在试点市场内完成备案的企业",
              advantage: "门槛相对较低，操作灵活",
              challenge: "地域限制，需在试点区域"
            }
          },
          {
            dimension: "通关单证",
            generalTrade: {
              value: "发票、箱单、合同等齐全",
              detail: "需要完整的单证链，每份文件都要求准确",
              advantage: "单证规范，便于后续跟踪",
              challenge: "单证要求高，制作成本大"
            },
            marketPurchase: {
              value: "简化申报，在信息平台录入",
              detail: "通过联网信息平台录入，简化申报流程",
              advantage: "申报简化，效率提升",
              challenge: "依赖平台系统，需确保信息准确"
            }
          },
          {
            dimension: "税务处理",
            generalTrade: {
              value: "征退制度（可退税）",
              detail: "出口环节征税，后续申请退税",
              advantage: "退税金额可观，降低实际成本",
              challenge: "退税周期长，占用资金"
            },
            marketPurchase: {
              value: "免征不退（不退税）",
              detail: "出口环节免征增值税，但不退税",
              advantage: "无需垫付税款，资金压力小",
              challenge: "无法享受退税收益"
            }
          },
          {
            dimension: "收汇要求",
            generalTrade: {
              value: "\"谁出口，谁收汇\"",
              detail: "出口企业必须是收汇主体，一一对应",
              advantage: "资金流向清晰，便于监管",
              challenge: "收汇灵活性受限"
            },
            marketPurchase: {
              value: "代理收汇，更灵活",
              detail: "可由代理公司统一收汇，支持个人账户",
              advantage: "收汇方式灵活，适合小额贸易",
              challenge: "需要选择可靠的代理机构"
            }
          },
          {
            dimension: "单票限额",
            generalTrade: {
              value: "无限制",
              detail: "对单票货值没有上限要求",
              advantage: "适合大额订单，无需拆分",
              challenge: "大额交易风险相对较高"
            },
            marketPurchase: {
              value: "≤15万美元",
              detail: "单票报关单货值不得超过15万美元",
              advantage: "适合中小额贸易，风险可控",
              challenge: "大额订单需要拆分处理"
            }
          },
          {
            dimension: "适用产品",
            generalTrade: {
              value: "几乎所有产品",
              detail: "除禁止出口商品外，基本无限制",
              advantage: "适用范围广，业务灵活性强",
              challenge: "某些产品监管要求较严"
            },
            marketPurchase: {
              value: "市场采购商品目录内",
              detail: "限于试点市场经营的商品品类",
              advantage: "针对性强，政策支持明确",
              challenge: "品类范围相对有限"
            }
          },
          {
            dimension: "适用企业",
            generalTrade: {
              value: "生产、贸易企业",
              detail: "适合有规模的生产型和贸易型企业",
              advantage: "利于品牌建设和规模发展",
              challenge: "对企业规范化要求较高"
            },
            marketPurchase: {
              value: "中小微企业、个体户",
              detail: "特别适合小规模、多品种的经营者",
              advantage: "门槛低，操作简便",
              challenge: "规模化发展存在限制"
            }
          }
        ]
      }
    },
    {
      id: 2,
      title: "如何选择？——决策路径图",
      subtitle: "科学决策工具",
      icon: "ri-route-line",
      content: {
        description: "通过三个核心问题，帮助企业快速确定最适合的贸易方式",
        decisionTree: [
          {
            step: 1,
            question: "你的公司/供应商能提供合格的增值税发票吗？",
            explanation: "这是享受出口退税政策的前提条件，也是区分两种贸易方式的核心标准",
            options: [
              {
                answer: "能够提供",
                result: "进入一般贸易通道",
                reasoning: "有发票支持，可享受退税政策，建议优先考虑一般贸易",
                nextStep: "继续评估其他因素",
                color: "green"
              },
              {
                answer: "无法提供",
                result: "考虑1039市场采购贸易",
                reasoning: "无票货物通过1039方式可合法出口，避免税务风险",
                nextStep: "进入问题2",
                color: "blue"
              }
            ],
            practicalTips: [
              "发票质量比数量更重要，确保发票真实有效",
              "如果部分有票部分无票，可考虑混合操作",
              "建立稳定的供应商发票管理体系"
            ]
          },
          {
            step: 2,
            question: "单批出口货值是否超过15万美元？",
            explanation: "1039贸易方式对单票货值有明确限制，超过限额需要特殊处理",
            options: [
              {
                answer: "超过15万美元",
                result: "必须拆单或走一般贸易",
                reasoning: "1039有货值上限，大额订单需要合理拆分或选择其他方式",
                nextStep: "评估拆单可行性",
                color: "orange"
              },
              {
                answer: "不超过15万美元",
                result: "可以考虑1039",
                reasoning: "符合1039货值要求，可以继续评估其他条件",
                nextStep: "完成决策评估",
                color: "green"
              }
            ],
            practicalTips: [
              "拆单时要确保每票货物的完整性和合理性",
              "避免为了拆单而人为分割自然商品",
              "考虑拆单对物流成本和客户体验的影响"
            ]
          }
        ],
        decisionMatrix: {
          title: "综合评估矩阵",
          factors: [
            {
              factor: "发票获取难度",
              weight: 30,
              generalTrade: { score: 8, description: "需要完整发票链" },
              marketPurchase: { score: 2, description: "无需发票" }
            },
            {
              factor: "单票货值水平",
              weight: 20,
              generalTrade: { score: 9, description: "无限制" },
              marketPurchase: { score: 6, description: "≤15万美元" }
            },
            {
              factor: "退税收益期望",
              weight: 25,
              generalTrade: { score: 9, description: "可享受退税" },
              marketPurchase: { score: 3, description: "免征不退" }
            },
            {
              factor: "操作复杂度",
              weight: 15,
              generalTrade: { score: 4, description: "流程复杂" },
              marketPurchase: { score: 8, description: "相对简化" }
            },
            {
              factor: "资金周转要求",
              weight: 10,
              generalTrade: { score: 5, description: "退税周期长" },
              marketPurchase: { score: 8, description: "无需垫付" }
            }
          ]
        }
      }
    },
    {
      id: 3,
      title: "常见风险与防控",
      subtitle: "风险识别与应对策略",
      icon: "ri-shield-check-line",
      content: {
        description: "识别两种贸易方式的主要风险点，提供针对性的防控措施",
        riskCategories: [
          {
            category: "一般贸易风险",
            color: "from-red-500 to-red-600",
            risks: [
              {
                riskType: "退税风险",
                description: "单证不符、超期申报导致退税失败或延误",
                specificRisks: [
                  "发票与报关单信息不一致",
                  "超过退税申报期限",
                  "单证缺失或不规范",
                  "汇率核算错误"
                ],
                preventionMeasures: [
                  "建立严格的单证审核制度",
                  "设立退税申报时间提醒系统",
                  "定期培训财务人员退税知识",
                  "建立与报关行的沟通机制"
                ],
                impact: "可能损失10-13%的退税收益",
                probability: "中等",
                solutions: [
                  "发现问题及时补正",
                  "与税务部门积极沟通",
                  "必要时寻求专业机构协助"
                ]
              },
              {
                riskType: "海关查验风险",
                description: "品名、价格、归类申报不实导致的海关处罚",
                specificRisks: [
                  "商品归类错误",
                  "价格申报偏离市场价格",
                  "品名描述不准确",
                  "原产地标识问题"
                ],
                preventionMeasures: [
                  "建立商品归类数据库",
                  "定期关注海关政策变化",
                  "与经验丰富的报关行合作",
                  "建立价格申报合理性审核机制"
                ],
                impact: "可能面临罚款和货物扣留",
                probability: "较低",
                solutions: [
                  "主动配合海关查验",
                  "提供充分的证明材料",
                  "必要时申请海关行政复议"
                ]
              },
              {
                riskType: "汇率风险",
                description: "汇率波动对企业收益的影响",
                specificRisks: [
                  "合同签订到收汇期间汇率大幅波动",
                  "退税核算汇率与实际收汇汇率差异",
                  "多币种结算带来的汇率风险"
                ],
                preventionMeasures: [
                  "合理使用汇率避险工具",
                  "优化收汇时间安排",
                  "在合同中约定汇率条款",
                  "分散币种风险"
                ],
                impact: "可能影响5-15%的利润",
                probability: "较高",
                solutions: [
                  "采用远期结汇等避险工具",
                  "调整产品定价策略",
                  "优化收汇节奏"
                ]
              }
            ]
          },
          {
            category: "市场采购贸易风险",
            color: "from-purple-500 to-purple-600",
            risks: [
              {
                riskType: "政策滥用风险",
                description: "高报低出、洗钱等违规操作带来的法律风险",
                specificRisks: [
                  "虚报贸易额套取外汇",
                  "利用1039进行资金转移",
                  "与实际贸易不符的申报",
                  "恶意拆单规避监管"
                ],
                preventionMeasures: [
                  "如实录入联网信息平台",
                  "确保贸易真实性",
                  "建立内控合规制度",
                  "定期进行合规培训"
                ],
                impact: "可能面临刑事处罚和市场禁入",
                probability: "低但后果严重",
                solutions: [
                  "立即停止违规行为",
                  "主动向监管部门报告",
                  "寻求专业法律援助"
                ]
              },
              {
                riskType: "产品侵权风险",
                description: "出口假冒伪劣商品导致的知识产权纠纷",
                specificRisks: [
                  "出口侵犯他人商标的商品",
                  "销售假冒品牌产品",
                  "专利侵权产品出口",
                  "版权侵权商品贸易"
                ],
                preventionMeasures: [
                  "建立供应商资质审核制度",
                  "对重点商品进行知识产权核查",
                  "建立商品合规性数据库",
                  "与知识产权服务机构合作"
                ],
                impact: "可能面临巨额赔偿和刑事责任",
                probability: "中等",
                solutions: [
                  "立即停止相关产品出口",
                  "与权利人协商解决",
                  "寻求知识产权律师协助"
                ]
              },
              {
                riskType: "代理风险",
                description: "依赖代理公司操作产生的业务和资金风险",
                specificRisks: [
                  "代理公司操作不规范",
                  "资金安全无法保障",
                  "服务质量参差不齐",
                  "代理费用不透明"
                ],
                preventionMeasures: [
                  "选择有资质的代理机构",
                  "建立代理商评估体系",
                  "签订详细的服务协议",
                  "定期审核代理操作"
                ],
                impact: "可能造成经济损失和业务中断",
                probability: "中等",
                solutions: [
                  "及时更换不合格代理",
                  "通过法律途径追回损失",
                  "建立备选代理机制"
                ]
              }
            ]
          }
        ],
        riskManagementFramework: {
          title: "风险管理框架",
          phases: [
            {
              phase: "风险识别",
              activities: [
                "定期评估业务风险点",
                "收集行业风险信息",
                "建立风险清单",
                "识别新兴风险"
              ]
            },
            {
              phase: "风险评估",
              activities: [
                "分析风险发生概率",
                "评估风险影响程度",
                "确定风险优先级",
                "制定风险应对策略"
              ]
            },
            {
              phase: "风险控制",
              activities: [
                "建立内控制度",
                "实施预防措施",
                "定期监控检查",
                "持续改进优化"
              ]
            },
            {
              phase: "风险应对",
              activities: [
                "制定应急预案",
                "建立响应机制",
                "及时处置风险事件",
                "总结经验教训"
              ]
            }
          ]
        }
      }
    }
  ];

  const decisionSteps = [
    {
      title: "发票能力评估",
      description: "评估企业获取增值税发票的能力"
    },
    {
      title: "货值规模分析",
      description: "分析单批次出口货值水平"
    },
    {
      title: "地域条件确认",
      description: "确认是否符合试点市场要求"
    },
    {
      title: "综合决策",
      description: "基于评估结果做出最终选择"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-orange-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-graduation-cap-line text-white text-xl"></i>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "Pacifico, serif" }}>天健外贸培训学院</h1>
                <p className="text-sm text-gray-600">专业外贸知识培训平台</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/')}
                className="px-4 py-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                返回首页
              </button>
              <button className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                立即报名
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/f9a2465dc548aa0aebf03e2fe472f817.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-orange-900/90 to-red-900/70"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 py-16">
          <div className="max-w-4xl">
            <div className="flex items-center space-x-3 mb-4">
              <span className="bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-medium">模块四</span>
              <span className="bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium">1小时</span>
            </div>
            <h1 className="text-5xl font-bold text-white mb-4 leading-tight">
              对比、选择与风险防控
            </h1>
            <p className="text-xl text-orange-100 mb-6">
              实战应用 · 提供决策工具，让学员能根据实际情况选择最优贸易方式，并识别主要风险
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 mb-8">
              <h3 className="text-lg font-semibold text-white mb-3">培训目标：</h3>
              <p className="text-orange-100 leading-relaxed">
                通过本模块学习，学员将掌握科学的贸易方式选择方法，能够准确识别和防控关键风险，
                具备独立进行贸易方式决策的能力，成为外贸实战专家。
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Course Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">详细内容</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            三大核心主题，掌握贸易方式选择与风险防控的实战技能
          </p>
        </div>

        {/* Content Sections */}
        <div className="space-y-8">
          {sections.map((section, index) => (
            <div key={section.id} className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div 
                className="bg-gradient-to-r from-orange-600 to-orange-700 p-6 cursor-pointer"
                onClick={() => setActiveSection(activeSection === section.id ? null : section.id)}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                      <i className={`${section.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <div className="flex items-center space-x-3 mb-2">
                        <span className="bg-white/20 text-white px-3 py-1 rounded-full text-sm font-medium">
                          主题{index + 1}
                        </span>
                      </div>
                      <h3 className="text-2xl font-bold text-white mb-1">{section.title}</h3>
                      <p className="text-white/80 text-lg">{section.subtitle}</p>
                    </div>
                  </div>
                  <div className="text-white">
                    <i className={`${activeSection === section.id ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-2xl`}></i>
                  </div>
                </div>
              </div>
              
              {activeSection === section.id && (
                <div className="p-8">
                  {/* Section 1: 对比表 */}
                  {section.id === 1 && (
                    <div>
                      <p className="text-lg text-gray-700 mb-8">{section.content.description}</p>
                      
                      <div className="space-y-6">
                        {section.content.comparisonTable.map((item, idx) => (
                          <div key={idx} className="bg-gray-50 rounded-2xl p-8">
                            <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                              <i className="ri-scales-3-line mr-3 text-orange-600"></i>
                              {item.dimension}
                            </h4>
                            
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                              {/* 一般贸易 */}
                              <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
                                <div className="text-center mb-4">
                                  <h5 className="text-xl font-bold text-blue-900">一般贸易 (0110)</h5>
                                </div>
                                
                                <div className="space-y-4">
                                  <div className="bg-white rounded-lg p-4">
                                    <h6 className="font-semibold text-blue-900 mb-2">核心特征</h6>
                                    <p className="text-blue-800 font-medium">{item.generalTrade.value}</p>
                                    <p className="text-blue-700 text-sm mt-2">{item.generalTrade.detail}</p>
                                  </div>
                                  
                                  <div className="bg-green-50 rounded-lg p-4">
                                    <h6 className="font-semibold text-green-900 mb-2">
                                      <i className="ri-thumb-up-line mr-1"></i>
                                      优势
                                    </h6>
                                    <p className="text-green-800 text-sm">{item.generalTrade.advantage}</p>
                                  </div>
                                  
                                  <div className="bg-red-50 rounded-lg p-4">
                                    <h6 className="font-semibold text-red-900 mb-2">
                                      <i className="ri-alert-line mr-1"></i>
                                      挑战
                                    </h6>
                                    <p className="text-red-800 text-sm">{item.generalTrade.challenge}</p>
                                  </div>
                                </div>
                              </div>
                              
                              {/* 市场采购贸易 */}
                              <div className="bg-purple-50 rounded-xl p-6 border border-purple-200">
                                <div className="text-center mb-4">
                                  <h5 className="text-xl font-bold text-purple-900">市场采购贸易 (1039)</h5>
                                </div>
                                
                                <div className="space-y-4">
                                  <div className="bg-white rounded-lg p-4">
                                    <h6 className="font-semibold text-purple-900 mb-2">核心特征</h6>
                                    <p className="text-purple-800 font-medium">{item.marketPurchase.value}</p>
                                    <p className="text-purple-700 text-sm mt-2">{item.marketPurchase.detail}</p>
                                  </div>
                                  
                                  <div className="bg-green-50 rounded-lg p-4">
                                    <h6 className="font-semibold text-green-900 mb-2">
                                      <i className="ri-thumb-up-line mr-1"></i>
                                      优势
                                    </h6>
                                    <p className="text-green-800 text-sm">{item.marketPurchase.advantage}</p>
                                  </div>
                                  
                                  <div className="bg-red-50 rounded-lg p-4">
                                    <h6 className="font-semibold text-red-900 mb-2">
                                      <i className="ri-alert-line mr-1"></i>
                                      挑战
                                    </h6>
                                    <p className="text-red-800 text-sm">{item.marketPurchase.challenge}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Section 2: 决策路径图 */}
                  {section.id === 2 && (
                    <div>
                      <p className="text-lg text-gray-700 mb-8">{section.content.description}</p>
                      
                      {/* 决策步骤导航 */}
                      <div className="mb-12">
                        <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                          <i className="ri-mind-map mr-3 text-orange-600"></i>
                          决策流程导航
                        </h4>
                        <div className="flex justify-center">
                          <div className="flex items-center space-x-4 overflow-x-auto pb-4">
                            {decisionSteps.map((step, idx) => (
                              <div key={idx} className="flex items-center flex-shrink-0">
                                <div 
                                  className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg cursor-pointer transition-colors ${
                                    currentStep === idx 
                                      ? 'bg-orange-500 text-white' 
                                      : currentStep > idx 
                                        ? 'bg-green-500 text-white'
                                        : 'bg-gray-200 text-gray-600'
                                  }`}
                                  onClick={() => setCurrentStep(idx)}
                                >
                                  {currentStep > idx ? <i className="ri-check-line"></i> : idx + 1}
                                </div>
                                <div className="ml-3 min-w-0">
                                  <p className="font-semibold text-gray-900 text-sm">{step.title}</p>
                                  <p className="text-gray-600 text-xs">{step.description}</p>
                                </div>
                                {idx < decisionSteps.length - 1 && (
                                  <div className="mx-4 w-8 h-0.5 bg-gray-300"></div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      
                      {/* 决策树详解 */}
                      <div className="space-y-8">
                        {section.content.decisionTree.map((node, idx) => (
                          <div key={idx} className="bg-gradient-to-r from-orange-50 to-yellow-50 rounded-2xl p-8 border border-orange-200">
                            <div className="text-center mb-6">
                              <div className="inline-flex items-center space-x-3 bg-orange-500 text-white px-6 py-3 rounded-full">
                                <span className="text-lg font-bold">问题 {node.step}</span>
                              </div>
                            </div>
                            
                            <h4 className="text-2xl font-bold text-gray-900 mb-4 text-center">{node.question}</h4>
                            <p className="text-gray-700 text-center mb-8">{node.explanation}</p>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                              {node.options.map((option, optionIdx) => (
                                <div key={optionIdx} className={`bg-white rounded-xl p-6 border-2 ${
                                  option.color === 'green' ? 'border-green-300' :
                                  option.color === 'blue' ? 'border-blue-300' :
                                  option.color === 'orange' ? 'border-orange-300' :
                                  'border-yellow-300'
                                }`}>
                                  <div className="text-center mb-4">
                                    <div className={`inline-flex items-center px-4 py-2 rounded-full text-white font-semibold ${
                                      option.color === 'green' ? 'bg-green-500' :
                                      option.color === 'blue' ? 'bg-blue-500' :
                                      option.color === 'orange' ? 'bg-orange-500' :
                                      'bg-yellow-500'
                                    }`}>
                                      {option.answer}
                                    </div>
                                  </div>
                                  
                                  <div className="space-y-3">
                                    <div className={`rounded-lg p-3 ${
                                      option.color === 'green' ? 'bg-green-50' :
                                      option.color === 'blue' ? 'bg-blue-50' :
                                      option.color === 'orange' ? 'bg-orange-50' :
                                      'bg-yellow-50'
                                    }`}>
                                      <h6 className="font-semibold mb-2">建议结果</h6>
                                      <p className="text-sm font-medium">{option.result}</p>
                                    </div>
                                    
                                    <div className="bg-gray-50 rounded-lg p-3">
                                      <h6 className="font-semibold mb-2">reasoning</h6>
                                      <p className="text-sm">{option.reasoning}</p>
                                    </div>
                                    
                                    <div className="bg-blue-50 rounded-lg p-3">
                                      <h6 className="font-semibold mb-2">下一步</h6>
                                      <p className="text-sm text-blue-800">{option.nextStep}</p>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            
                            <div className="bg-white rounded-xl p-6 border border-gray-200">
                              <h5 className="font-semibold text-gray-900 mb-3">
                                <i className="ri-lightbulb-line mr-2 text-yellow-500"></i>
                                实操建议
                              </h5>
                              <ul className="space-y-2">
                                {node.practicalTips.map((tip, tipIdx) => (
                                  <li key={tipIdx} className="flex items-start text-sm text-gray-700">
                                    <i className="ri-star-line mr-2 mt-0.5 text-yellow-500 flex-shrink-0"></i>
                                    {tip}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        ))}
                      </div>
                      
                      {/* 综合评估矩阵 */}
                      <div className="mt-12 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-8">
                        <h4 className="text-2xl font-bold text-gray-900 mb-8 text-center">
                          <i className="ri-bar-chart-box-line mr-3 text-indigo-600"></i>
                          {section.content.decisionMatrix.title}
                        </h4>
                        
                        <div className="space-y-6">
                          {section.content.decisionMatrix.factors.map((factor, idx) => (
                            <div key={idx} className="bg-white rounded-xl p-6 border border-indigo-200">
                              <div className="flex items-center justify-between mb-4">
                                <h5 className="text-lg font-bold text-gray-900">{factor.factor}</h5>
                                <div className="flex items-center space-x-2">
                                  <span className="bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full text-sm font-medium">
                                    权重: {factor.weight}%
                                  </span>
                                </div>
                              </div>
                              
                              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                <div className="bg-blue-50 rounded-lg p-4">
                                  <div className="flex items-center justify-between mb-2">
                                    <h6 className="font-semibold text-blue-900">一般贸易</h6>
                                    <div className="flex items-center space-x-2">
                                      <div className="flex space-x-1">
                                        {[...Array(10)].map((_, i) => (
                                          <div
                                            key={i}
                                            className={`w-3 h-3 rounded-full ${
                                              i < factor.generalTrade.score ? 'bg-blue-500' : 'bg-gray-200'
                                            }`}
                                          />
                                        ))}
                                      </div>
                                      <span className="text-blue-900 font-bold">{factor.generalTrade.score}/10</span>
                                    </div>
                                  </div>
                                  <p className="text-blue-800 text-sm">{factor.generalTrade.description}</p>
                                </div>
                                
                                <div className="bg-purple-50 rounded-lg p-4">
                                  <div className="flex items-center justify-between mb-2">
                                    <h6 className="font-semibold text-purple-900">市场采购贸易</h6>
                                    <div className="flex items-center space-x-2">
                                      <div className="flex space-x-1">
                                        {[...Array(10)].map((_, i) => (
                                          <div
                                            key={i}
                                            className={`w-3 h-3 rounded-full ${
                                              i < factor.marketPurchase.score ? 'bg-purple-500' : 'bg-gray-200'
                                            }`}
                                          />
                                        ))}
                                      </div>
                                      <span className="text-purple-900 font-bold">{factor.marketPurchase.score}/10</span>
                                    </div>
                                  </div>
                                  <p className="text-purple-800 text-sm">{factor.marketPurchase.description}</p>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Section 3: 风险防控 */}
                  {section.id === 3 && (
                    <div>
                      <p className="text-lg text-gray-700 mb-8">{section.content.description}</p>
                      
                      <div className="space-y-8">
                        {section.content.riskCategories.map((category, categoryIdx) => (
                          <div key={categoryIdx} className="bg-white border border-gray-200 rounded-2xl overflow-hidden">
                            <div className={`bg-gradient-to-r ${category.color} p-6 text-white`}>
                              <h4 className="text-2xl font-bold mb-2">{category.category}</h4>
                              <p className="text-white/80">识别关键风险点，制定针对性防控措施</p>
                            </div>
                            
                            <div className="p-8">
                              <div className="space-y-8">
                                {category.risks.map((risk, riskIdx) => (
                                  <div key={riskIdx} className="bg-gray-50 rounded-2xl p-6">
                                    <div className="flex items-start justify-between mb-6">
                                      <div>
                                        <h5 className="text-xl font-bold text-gray-900 mb-2">{risk.riskType}</h5>
                                        <p className="text-gray-700">{risk.description}</p>
                                      </div>
                                      <div className="flex items-center space-x-4 text-sm">
                                        <div className="text-center">
                                          <p className="font-semibold text-gray-900">影响程度</p>
                                          <p className="text-red-600">{risk.impact}</p>
                                        </div>
                                        <div className="text-center">
                                          <p className="font-semibold text-gray-900">发生概率</p>
                                          <p className="text-orange-600">{risk.probability}</p>
                                        </div>
                                      </div>
                                    </div>
                                    
                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                                      <div className="bg-red-50 rounded-xl p-4">
                                        <h6 className="font-semibold text-red-900 mb-3">
                                          <i className="ri-error-warning-line mr-2"></i>
                                          具体风险
                                        </h6>
                                        <ul className="space-y-2">
                                          {risk.specificRisks.map((specificRisk, idx) => (
                                            <li key={idx} className="flex items-start text-sm text-red-800">
                                              <i className="ri-alert-line mr-2 mt-0.5 flex-shrink-0"></i>
                                              {specificRisk}
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                      
                                      <div className="bg-blue-50 rounded-xl p-4">
                                        <h6 className="font-semibold text-blue-900 mb-3">
                                          <i className="ri-shield-check-line mr-2"></i>
                                          预防措施
                                        </h6>
                                        <ul className="space-y-2">
                                          {risk.preventionMeasures.map((measure, idx) => (
                                            <li key={idx} className="flex items-start text-sm text-blue-800">
                                              <i className="ri-check-line mr-2 mt-0.5 flex-shrink-0"></i>
                                              {measure}
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                      
                                      <div className="bg-green-50 rounded-xl p-4">
                                        <h6 className="font-semibold text-green-900 mb-3">
                                          <i className="ri-tools-line mr-2"></i>
                                          应对方案
                                        </h6>
                                        <ul className="space-y-2">
                                          {risk.solutions.map((solution, idx) => (
                                            <li key={idx} className="flex items-start text-sm text-green-800">
                                              <i className="ri-lightbulb-line mr-2 mt-0.5 flex-shrink-0"></i>
                                              {solution}
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      
                      {/* 风险管理框架 */}
                      <div className="mt-12 bg-gradient-to-r from-slate-50 to-gray-50 rounded-2xl p-8">
                        <h4 className="text-2xl font-bold text-gray-900 mb-8 text-center">
                          <i className="ri-dashboard-line mr-3 text-slate-600"></i>
                          {section.content.riskManagementFramework.title}
                        </h4>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                          {section.content.riskManagementFramework.phases.map((phase, idx) => (
                            <div key={idx} className="bg-white rounded-xl p-6 border border-gray-200 text-center">
                              <div className="w-16 h-16 bg-gradient-to-r from-slate-500 to-slate-600 rounded-full flex items-center justify-center mx-auto mb-4">
                                <span className="text-white font-bold text-xl">{idx + 1}</span>
                              </div>
                              <h5 className="text-lg font-bold text-gray-900 mb-4">{phase.phase}</h5>
                              <ul className="space-y-2">
                                {phase.activities.map((activity, activityIdx) => (
                                  <li key={activityIdx} className="text-sm text-gray-700">
                                    • {activity}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-orange-600 to-red-600 py-16">
        <div className="max-w-4xl mx-auto text-center px-6">
          <h2 className="text-4xl font-bold text-white mb-4">
            成为外贸决策专家
          </h2>
          <p className="text-xl text-orange-100 mb-8 leading-relaxed">
            掌握科学决策方法，识别关键风险点，让每一次贸易选择都精准高效
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button className="px-8 py-4 bg-white text-orange-600 rounded-lg hover:bg-gray-50 transition-colors font-semibold whitespace-nowrap cursor-pointer">
              <i className="ri-user-add-line mr-2"></i>
              立即报名学习
            </button>
            <button className="px-8 py-4 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors backdrop-blur-sm font-semibold whitespace-nowrap cursor-pointer">
              <i className="ri-download-line mr-2"></i>
              下载决策工具
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                  <i className="ri-graduation-cap-line text-white"></i>
                </div>
                <h3 className="text-xl font-bold" style={{ fontFamily: "Pacifico, serif" }}>天健外贸培训学院</h3>
              </div>
              <p className="text-gray-400 mb-4">专业的外贸知识培训平台，助您成为外贸专家</p>
              <div className="flex space-x-4">
                <i className="ri-wechat-line text-xl text-gray-400 hover:text-white cursor-pointer transition-colors"></i>
                <i className="ri-qq-line text-xl text-gray-400 hover:text-white cursor-pointer transition-colors"></i>
                <i className="ri-mail-line text-xl text-gray-400 hover:text-white cursor-pointer transition-colors"></i>
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">课程内容</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">外贸基础入门</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">一般贸易解析</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">市场采购贸易</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">风险防控</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">学习支持</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">在线答疑</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">实战案例</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">学习资料</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">证书认证</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">快速链接</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">关于我们</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">联系方式</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">服务条款</a></li>
                <li><a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Made with Readdy</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 天健外贸培训学院. 保留所有权利.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
